import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {useTranslation} from '@/translations/i18n'
import {ObjectKeys} from '@/utilities/helpers'
import {useFormContext} from 'react-hook-form'
import {To} from 'react-router-dom'
import {z} from 'zod'

export const PlannedAccessesFormHeading = ({
    title,
    schema,
    showConfirmationDialog,
    isEdit,
    isMissingExpirationDate,
    onError
}: {
    title: string
    schema: z.ZodSchema
    showConfirmationDialog: () => void
    isEdit?: boolean
    isMissingExpirationDate?: boolean
    onError: () => void
}) => {
    const {t} = useTranslation()
    const {
        handleSubmit,
        getValues,
        formState: {errors}
    } = useFormContext<z.infer<typeof schema>>()

    const onSubmit = handleSubmit(
        () => showConfirmationDialog(),
        errors => {
            console.error('Project form submission validation errors: ', {
                errors,
                values: getValues()
            })
            onError()
        }
    )

    return (
        <PageHeading align="center" justify="space-between">
            <h2>{title}</h2>
            <Flexbox gap={2}>
                <ButtonLink to={-1 as To} variant="secondary">
                    {t('commons:cancel')}
                </ButtonLink>
                <Button
                    variant="primaryNeutral"
                    onClick={onSubmit}
                    disabled={ObjectKeys(errors).length > 0 || isMissingExpirationDate}
                >
                    {isEdit ? t('commons:save') : t('commons:add')}
                </Button>
            </Flexbox>
        </PageHeading>
    )
}
